module.exports = __webpack_public_path__ + "img/start-tour-girl.751587ed.png";